import { Box, Button, Modal } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";

const ExpenseBreakup = ({ isBreakupOpen, handleBreakupClose, data }) => {
  console.log("dtaa", data);

  return (
    <>
      <Modal open={isBreakupOpen} onClose={handleBreakupClose}>
        <Box
          sx={{
            width: "40%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              Expense Breakup
            </p>

            <Chart
              type="donut"
              width={"100%"}
              height={"100%"}
              series={data?.map((d) => d?.totalAmount)}
              options={{
                labels: data?.map((d) => d?._id),
                yaxis: {
                  labels: {},
                },
                legend: {
                  position: "bottom",
                },
              }}
            />

            <Button
              variant="outlined"
              onClick={handleBreakupClose}
              style={{ width: "200px", marginLeft: "auto", marginTop: "1rem" }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ExpenseBreakup;
